<template>
  <div id="app">
    <theme-styles />
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import '@/css/main.scss'
import ThemeStyles from '@/components/ThemeStyles.vue'

export default {
  name: "App",
  components: {
    ThemeStyles
  },
  created () {
    // 调试模式检测
    const debug = this.$global.GetQueryString('db');
    if (debug) {
      this.$store.commit('setDebug', true);
    }

    // 设备类型检测和存储
    // SSR场景下，设备类型在服务端已经确定并注入到state中。
    // 客户端不应重新检测和覆盖，否则可能导致服务端渲染的内容和客户端状态不匹配，从而引起页面闪烁。
    // 仅当store中没有设备类型时（例如纯客户端渲染场景）才进行检测。
    if (!this.$store.state.deviceType) {
      const deviceType = this.detectDeviceType();
      this.$store.commit('setDeviceType', deviceType);
    }

  },
  beforeMount () {
    // 初始化品牌列表数据
    this.initBrandList();
  },
  methods: {
    // 初始化品牌列表数据
    async initBrandList () {
      // 如果品牌列表已加载，则不重复请求
      if (this.$store.getters.brandListLoaded) {
        console.log('品牌列表已加载，不再重复请求');
        return;
      }

      try {
        console.log('App.vue 初始化获取品牌列表');
        const response = await this.$global.server.getCarNameList();

        // 确保响应成功且数据格式正确
        if (response && response.code === 200 && response.data) {
          let brands = [];

          // 处理可能的不同响应格式
          if (Array.isArray(response.data)) {
            brands = response.data;
          } else if (response.data.list && Array.isArray(response.data.list)) {
            brands = response.data.list;
          }

          if (brands.length > 0) {
            // 确保返回的数据包含name和value
            const formattedBrands = [
              { label: 'All', value: 'all' },
              ...brands.map(item => ({
                label: item.name || item.label || item,
                value: item.value || item.name || item
              }))
            ];

            // 存储到Vuex中
            this.$store.commit('SET_BRAND_LIST', formattedBrands);
            this.$store.commit('SET_BRAND_LIST_LOADED', true);

            console.log('品牌列表获取成功并已存储到Vuex中');
          }
        } else {
          console.error('获取品牌列表失败', response);
        }
      } catch (error) {
        console.error('获取品牌列表出错', error);
      }
    },
    detectDeviceType () {
      try {
        // SSR 环境检测
        if (typeof this.$ssrContext !== 'undefined' && this.$ssrContext.device) {
          return this.$ssrContext.device;
        }

        // 客户端环境检测
        if (typeof window !== 'undefined') {
          const userAgent = navigator.userAgent.toLowerCase();

          // 平板设备检测
          const isTablet = /ipad|tablet|(android(?!.*mobile))/i.test(userAgent);
          if (isTablet) return 'tablet';

          // 移动设备检测
          const isMobile = /mobile|android|iphone|phone|webos|ipod|blackberry|windows phone/i.test(userAgent);
          if (isMobile) return 'mobile';

          // 增加触摸设备检测作为辅助判断
          const hasTouch = 'ontouchstart' in window || navigator.maxTouchPoints > 0;
          if (hasTouch && window.innerWidth < 768) return 'mobile';
        }

        return 'desktop';
      } catch (error) {
        console.warn('设备类型检测失败:', error);
        return 'desktop'; // 发生错误时返回默认值
      }
    }
  }
};
</script>
